/**
 * Sekme grubu renkleri.
 *
 * Renkler Tailwind token'ı değil sabit hex: grup rengi kullanıcının seçtiği şey, temaya
 * göre kaymamalı — koyu temada da aynı grup aynı renkte görünür. Yalnızca doygunluk/parlaklık
 * koyu tema için ayrı tutuluyor, yoksa açık renkler koyu zeminde göz alıyor.
 *
 * `fg` her rengin üstünde okunur kontrastı verecek şekilde elle seçildi; hesaplamak yerine
 * tablo tutmak, dokuz sabit renk için hem daha ucuz hem daha kesin.
 */
import type { TabGroupColor } from '../model/types';

export interface TabGroupPalette {
  /** Grup çipinin zemini. */
  bg: string;
  /** Çip üstündeki metin/ikon rengi. */
  fg: string;
  /** Gruba ait sekmelerin altındaki ince şerit ve blok çerçevesi. */
  edge: string;
}

export const TAB_GROUP_COLORS: Record<TabGroupColor, TabGroupPalette> = {
  grey: { bg: '#5f6368', fg: '#ffffff', edge: '#8a8f94' },
  blue: { bg: '#1a73e8', fg: '#ffffff', edge: '#5b9bf3' },
  red: { bg: '#d93025', fg: '#ffffff', edge: '#ef6a5f' },
  yellow: { bg: '#f9ab00', fg: '#202124', edge: '#fbc55a' },
  green: { bg: '#188038', fg: '#ffffff', edge: '#4fa96a' },
  pink: { bg: '#d01884', fg: '#ffffff', edge: '#e563ad' },
  purple: { bg: '#9334e6', fg: '#ffffff', edge: '#b673ee' },
  cyan: { bg: '#007b83', fg: '#ffffff', edge: '#3ba6ad' },
  orange: { bg: '#e8710a', fg: '#ffffff', edge: '#f09a4f' },
};

export const TAB_GROUP_COLOR_ORDER: TabGroupColor[] = [
  'grey',
  'blue',
  'red',
  'yellow',
  'green',
  'pink',
  'purple',
  'cyan',
  'orange',
];

export function groupPalette(color: TabGroupColor): TabGroupPalette {
  return TAB_GROUP_COLORS[color] ?? TAB_GROUP_COLORS.grey;
}
